"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importStar(require("styled-components"));
const Block = styled_components_1.default.div `
  padding: ${(props) => props.theme.spacing.medium};

  ${(props) => props.flex &&
    styled_components_1.css `
      height: 100%;
      display: flex;
      flex-direction: column;
    `};

  ${(props) => props.flexValue &&
    styled_components_1.css `
      flex: ${props.flexValue};
    `};

  ${(props) => props.centered &&
    styled_components_1.css `
      justify-content: center;
      align-items: center;
    `};

  ${(props) => props.tight &&
    styled_components_1.css `
      padding: ${(props) => props.theme.spacing.xs};
    `};

  ${(props) => props.hugBottom &&
    styled_components_1.css `
      padding-bottom: 0;
    `}

  ${(props) => props.hugTop &&
    styled_components_1.css `
      padding-top: 0;
    `}
`;
exports.default = Block;
